import { MenuItem, styled } from '@mui/material';

export const MenuItemReadonly = styled(MenuItem)({
    userSelect: 'text',
    opacity: '1 !important'
});

export const TenantIcon = styled('img')(({ theme }) => ({
    maxWidth: theme.spacing(5),
    maxHeight: theme.spacing(5)
}));
